import { FormCreate } from './create'
import { FormEdit } from './edit'
// import { FormEditor } from './editor';
import { FormList } from './list'

export default class Form {
  static Create = FormCreate
  static Edit = FormEdit
  static List = FormList
}
